export default function accordion() {
  try {
    const accordionItems = document.querySelectorAll(".refund-accordion");

    function setSizes() {
      accordionItems.forEach((item) => {
        item.style.maxHeight = "";
        item.classList.remove("active");

        const visible = item.querySelector(".js-accordion-open");
        const show = item.querySelector(".js-accordion-show");

        item.setAttribute("data-show-height", item.clientHeight);
        item.setAttribute(
          "data-visible-height",
          item.clientHeight - show.clientHeight
        );

        item.style.maxHeight = item.getAttribute("data-visible-height") + "px";
      });
    }

    function showAccordion() {
      accordionItems.forEach((item) => {
        const visible = item.querySelector(".js-accordion-open");
        const show = item.querySelector(".js-accordion-show");

        visible.addEventListener("click", () => {
          if (item.classList.contains("active")) {
            item.classList.remove("active");
            item.style.maxHeight =
              item.getAttribute("data-visible-height") + "px";
          } else {
            item.classList.add("active");
            item.style.maxHeight = item.getAttribute("data-show-height") + "px";
          }
        });
      });
    }

    showAccordion();
    setSizes();
    // window.addEventListener("resize", setSizes);
  } catch (e) {}
}
